import { useCallback, useState } from "react";

export function useRequest(serviceFn, { initialData = [] } = {}) {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  const execute = useCallback(async (...args) => {
    setLoading(true);
    const { status, data, message } = await serviceFn(...args);
    if (status === 200) {
      setData(data);
    } else {
      console.error("Erro:", message);
    }
    setLoading(false);
    return { status, data, message };
  }, [serviceFn]);

  return { data, loading, execute, setData };
}
